import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ChangeLogService } from '../services/change-log.service';

export const changeLogResolver: ResolveFn<boolean> = async (route, _state) => {
  const changelogService = inject(ChangeLogService);
  const id = route.parent?.params['id'] as string;
  await changelogService.loadChangeLogs(id);
  return true;
};
